module.exports = __webpack_public_path__ + "img/menu-bar-on_01.47cfc499.png";